/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLetterYSmall = createReactComponent("letter-y-small", "IconLetterYSmall", [
  ["path", { d: "M10 8l2 5l2 -5", key: "svg-0" }],
  ["path", { d: "M12 16v-3", key: "svg-1" }]
]);

export { IconLetterYSmall as default };
//# sourceMappingURL=IconLetterYSmall.js.map
